import {determineLife, calcAgeDeath, extractIncome, incomeValid, isChild} from 'services/personFunctions';
import {personTemplate, defaultIncomePeriodTemplate, paymentsTemplate} from 'store/modules/shared/templates';
import {validDate} from 'components/form/validator/validations';
import {areAllTrue, dateFromServer} from 'services/helper';
import Api from 'services/Api';
import _ from 'lodash';
import moment from 'moment';
import store from 'store/index';
import Vue from 'vue';
import Validator from 'services/Validator';
import { previousValid } from 'store/generators/step';
import {requestPayload} from 'store/modules/claim';

/**
 * Mutation Types
 * 
 * @type {Object}
 */
const mutationTypes = {
    ADD_INTERIM_PAYMENT: 'ADD_INTERIM_PAYMENT',
    UPDATE_INTERIM_PAYMENT: 'UPDATE_INTERIM_PAYMENT',
    DELETE_INTERIM_PAYMENT: 'DELETE_INTERIM_PAYMENT',
    UPDATE_FROM_SERVER: 'UPDATE_FROM_SERVER',
    RESET: 'RESET',
    SET: 'SET',
};

const numberVal = value => parseFloat(value || 0);

/**
 * Initial State
 * 
 * @type {Object}
 */
const state = {
    payments: [],
};

/**
 * Validation Rules.
 * 
 * @type {Object}
 */
const rules = {
    
};

/**
 * Getters.
 * 
 * @type {Object}
 */
const getters = {
    interimPayments: state => state.payments,
    findPayment: state => index => state.payments[index],
    getAllInterimPaymentsTotal: state => state.payments.reduce((total, interimPayment) => total + numberVal(interimPayment.value), 0),
    allInterimPaymentsValid: (state) => {
        let maxDate = moment(store.getters['lost/headsOfLoss/interestDate'], 'DD/MM/YYYY');
        return state.payments.reduce(function(valid, payment) {
            let mPaymentDate = moment(payment.date, 'DD/MM/YYYY');
            return !valid ? valid : (mPaymentDate.isValid() && payment.value > 0 && mPaymentDate.isBefore(maxDate));
        }, true);
    }
};

// Actions
const actions = {
    /**
     * Save the step by submitting to the server.
     */
    save({getters, dispatch}, payload) {
        // We might change this to something which 
        // is a bit cleaner...
        payload.data = state;

        Api.claims.save(payload).then((response) => {
            return response;
        });

        store.dispatch('lost/save', requestPayload(4));
    },
    /**
     * Loads the step being received from the Server, to be placed in the state.
     */
    load({ dispatch, action, commit }, step) {
        const data = _.deeply(_.mapKeys)(step, (value, key) => _.camelCase(key)).data;

        commit(mutationTypes.SET, { key: 'payments', value: data.payments });
    },
    /**
     * Performs any processing once the data from the server has been stored.
     * This is a good place to do calculations or dispatch other actions which
     * are used to refresh/update calculated data on other steps/components.
     */
    process({ commit, dispatch }) {
        // This is not currently used.
    },
    /**
     * Validates the step once any processing is complete.
     *
     * @param commit
     * @param dispatch
     */
    validate({ commit, dispatch, rootState }) {
        store.dispatch('lost/step/setStepNumberValid', {
            stepNo: 6,
            valid:  previousValid(rootState, 6) && (new Validator(state, rules)).validate(),
        });
    },
    /**
     * Resets the step back to defaults
     */
    reset({ commit }) {
        store.dispatch('lost/step/setStepNumberValid', {
            stepNo: 6,
            valid: false,
        });
        
        commit(mutationTypes.RESET);
    },
    /**
     * Add an interim payment
     */
    addPayment({ commit }) {
        commit(mutationTypes.ADD_INTERIM_PAYMENT);
    },
    /**
     * Delete an interim payment
     */
    deletePayment({ commit }, index) {
        commit(mutationTypes.DELETE_INTERIM_PAYMENT, index);
    },
    /**
     * Update an existing interim payment
     */
    updatePayment({ commit, state }, { key, value, index }) {
        if (state.payments[index][key] === value) {
            return value;
        }
        commit(mutationTypes.UPDATE_INTERIM_PAYMENT, { key, value, index });
        return value;
    },
};

// Mutations
const mutations = {
    /**
     * Reset state.
     */
    [mutationTypes.RESET](state) {
        state.payments = [];
    },
    /**
     * Add interim payment to state.
     */
    [mutationTypes.ADD_INTERIM_PAYMENT](state) {
        state.payments.push(paymentsTemplate());
    },
    /**
     * Delete interim payment from state.
     */
    [mutationTypes.DELETE_INTERIM_PAYMENT](state, index) {
        if (index === 0 && state.payments.length === 1) {
            state.payments = [];
        }
        state.payments.splice(index, 1);
    },
    /**
     * Update interim payment in state.
     */
    [mutationTypes.UPDATE_INTERIM_PAYMENT](state, { key, value, index }) {
        state.payments[index][key] = value;
    },
    /**
     * Set an object on the state.
     */
    [mutationTypes.SET](state, payload) {
        // Might be able to do this nicer with Object.assign
        Vue.set(state, payload.key, payload.value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/lost/interimPayments.js